// This folder will hold translations, this is a dead way of doing things, but it is what it is, Google translate api will do this work later
export default  {
    dash:{
        en: "Dashboard",
        tr : "Gösterge Paneli"
    },job_history:{
        en: "Job history",
        tr : "İş geçmişi"
    },logout:{
        en: "Logout",
        tr : "oturumu Kapat"
    },life_earnings:{
        en: "Lifetime earnings",
        tr : "ömür boyu kazanç"
    },commissions_pay:{
        en: "Commissions payable",
        tr : "Ödenecek komisyonlar"
    },jobs_completed:{
        en: "Jobs completed",
        tr : "Tamamlandi İşler"
    },your_status:{
        en: "Your status",
        tr : "durum"
    },date:{
        en: "Date",
        tr : "Tarih"
    },price:{
        en: "Price",
        tr : "Fiyat"
    },enter_price:{
        en: "Enter price",
        tr : "girdi fiyatı"
    },activate_account:{
        en: "Activate account",
        tr : "Hesabınızı Etkinleştirin"
    },enter_email:{
        en: "Enter your email",
        tr : "E-postanızı giriniz"
    },input_activation:{
        en: "Input your activation code",
        tr : "Aktivasyon kodunuzu giriniz"
    },activate:{
        en: "Activate",
        tr : "Gonder"
    },set_a_password:{
        en: "Set a password",
        tr : "Bir şifre belirleyin"
    },password:{
        en: "Password",
        tr : "şifre"
    },confirm_password:{
        en: "Confirm password",
        tr : "Şifreyi Onayla"
    },submit:{
        en: "submit",
        tr : "Gonder"
    },commission:{
        en: "Commission",
        tr : "komisyon"
    },house_type:{
        en: "House type",
        tr : "Ev tipi"
    },sel_house_type:{
        en: "Select House type",
        tr : "Ev tipini seçin"
    },sel_city:{
        en: "Select City",
        tr : "Bir şehir seçin"
    },city:{
        en: "City",
        tr : "şehir"
    },email:{
        en: "Email",
        tr : "Eposta Adresi"
    },home:{
        en : "Home",
        tr: "Ev"
    },enabled:{
        en : "Enabled",
        tr : "Etkin"
    },disabled:{
        en : "Disabled",
        tr : "Devre Dişi"
    }


}